import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
var CircularBuffer = /*#__PURE__*/ function() {
    "use strict";
    function CircularBuffer(size) {
        _class_call_check(this, CircularBuffer);
        _define_property(this, "bufferSize", void 0);
        _define_property(this, "buffer", void 0);
        _define_property(this, "index", void 0);
        _define_property(this, "actualSize", void 0);
        this.bufferSize = size;
        this.buffer = new Array(size);
        this.index = 0;
        this.actualSize = 0;
    }
    _create_class(CircularBuffer, [
        {
            key: "size",
            get: function get() {
                return this.actualSize;
            }
        },
        {
            key: "push",
            value: function push(element) {
                this.buffer[this.index] = element;
                this.index = (this.index + 1) % this.bufferSize;
                this.actualSize = Math.min(this.actualSize + 1, this.bufferSize);
            }
        },
        {
            key: "get",
            value: function get(at) {
                if (this.actualSize === this.bufferSize) {
                    var index = (this.index + at) % this.bufferSize;
                    if (index < 0) {
                        index += this.bufferSize;
                    }
                    return this.buffer[index];
                } else {
                    return this.buffer[at];
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.buffer = new Array(this.bufferSize);
                this.index = 0;
                this.actualSize = 0;
            }
        }
    ]);
    return CircularBuffer;
}();
export { CircularBuffer as default };
